const staticPixels = "\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-W6FD9FK0F1&l=dataLayer\"></script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=UA-166288951-1&l=dataLayer\"></script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-XG5855GQ7X&l=dataLayer\"></script>";
const pixelsCategories = ["STRICTLY_NECESSARY","TARGETING"];

export { staticPixels };
export { pixelsCategories };